
import React from "react";
import { Star } from "lucide-react";
import { useDreams } from "@/hooks/useDreams";
import NewDreamForm from "./dreams/NewDreamForm";
import DreamsGrid from "./dreams/DreamsGrid";

const PassionTracker = () => {
  const { dreams, loading, addDream, deleteDream, updateKarmaPoints } = useDreams();

  return (
    <div className="p-6 bg-card rounded-lg shadow-sm border">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold flex items-center gap-2">
          <Star className="text-yellow-500" />
          Dream Board
        </h2>
        <NewDreamForm onAddDream={addDream} />
      </div>
      
      {loading ? (
        <div className="flex justify-center items-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        </div>
      ) : (
        <DreamsGrid 
          dreams={dreams} 
          onDelete={deleteDream} 
          updateKarmaPoints={updateKarmaPoints} 
        />
      )}
    </div>
  );
};

export default PassionTracker;
